module.exports = __webpack_public_path__ + "static/media/6540.dcd533e4.jpg";